import React, {useEffect, useState} from "react";
import ApplyField from "../fields/ApplyField";
import {Field, useForm, useFormState} from "react-final-form";
import {APPLY_STATUS_SUCCESS, checkCouponCode} from "../../actions/ApplyFieldActions";
import useApplyFieldStatus from "../../hooks/useApplyFieldStatus";

function PromoCode() {
    const fieldName = 'coupon';
    const errorMessage = "Please enter a valid promo code";
    const {change} = useForm();
    const {values} = useFormState();
    const [open, setOpen] = useState(!!values.coupon);
    const {checkStatus} = useApplyFieldStatus(fieldName);
    const codeIsApplied = checkStatus(APPLY_STATUS_SUCCESS);

    const onClickIcon = () => {
        setOpen(!open);
    }

    const onClickRemove = () => {
        change(fieldName, undefined);
    }

    useEffect(() => {
        setOpen(!!values.coupon || codeIsApplied);
    }, [codeIsApplied, values.coupon]);

    return <div className={`promo-code-wrap ${codeIsApplied ? 'promo-code-applied-wrap' : ''}`}>
        {!codeIsApplied && (
            <div className="promo-code-item" onClick={onClickIcon}>
                <div className="promo-code-item__icon">
                    <img
                        width="18px"
                        src={!open ? '/_core/assets/themes/v5/assets/img/form3/circle-plus.svg' : '/_core/assets/themes/v5/assets/img/form3/circle-minus.svg'}
                        alt="icon"
                    />
                </div>
                <p>Have a promo code?</p>
            </div>
        )}
        {(open || codeIsApplied) && (
            <Field
                name={fieldName}
                title="Promo code"
                component={ApplyField}
                placeholder="e.g. 653841"
                onClickApply={checkCouponCode}
                onClickRemove={onClickRemove}
                removable={true}
                errorMessage={errorMessage}
            />
        )}
    </div>
}

export default PromoCode;
